// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__3kgIg","image":"styles_image__3jttx","name":"styles_name__OYNyJ","price":"styles_price__101m4","count":"styles_count__3ZrGx"};